import { z } from 'zod';

export const giftFormSchema = z.object({
  name: z
    .string()
    .min(1, 'Tên quà tặng là bắt buộc')
    .refine(
      (val) => val.trim().length > 0,
      'Tên quà tặng không được chỉ chứa khoảng trắng'
    ),
  description: z
    .string()
    .min(1, 'Mô tả là bắt buộc')
    .refine(
      (val) => val.trim().length > 0,
      'Mô tả không được chỉ chứa khoảng trắng'
    ),
  remainingQuantity: z
    .number({
      required_error: 'Số lượng là bắt buộc',
      invalid_type_error: 'Vui lòng nhập số lượng',
    })
    .min(0, 'Số lượng phải lớn hơn hoặc bằng 0'),
  unitPrice: z
    .number({
      required_error: 'Đơn giá là bắt buộc',
      invalid_type_error: 'Vui lòng nhập đơn giá',
    })
    .min(0, 'Đơn giá phải lớn hơn hoặc bằng 0'),
  supplierId: z
    .string({
      required_error: 'Nhà cung cấp là bắt buộc',
      invalid_type_error: 'Vui lòng chọn nhà cung cấp',
    })
    .min(1, 'Vui lòng chọn nhà cung cấp'),
});

export type GiftFormValues = z.infer<typeof giftFormSchema>;
